/*----------------------------------------------- CUSTOMERS SECTION -----------------------------------------------*/
$(document).ready(function(){
  
 
  $('#customers .multiple-items').on('ready beforeChange', function(event, slick, currentSlide, nextSlide, preSlide){

    if ($(window).width() >= 1281) {

      $('#customers .slick-slide:not(.slick-active)').addClass('animated fadeInUp');
      $('#customers .multiple-items .fadeInUp').css({'animation-delay' : '300ms'});
      $('#customers .multiple-items .fadeInUp').css({'animation-duration' : '200ms'});


      setTimeout(function() { 
        $('#customers .slick-slide:not(.slick-active)').removeClass('animated fadeInUp');
      }, 1000);

 
      $('body').on('click', '.slick-next', function() {
       
        if (currentSlide == sliderCount - 1) {

          $('#customers .slick-slide.slick-center').removeClass('animated fadeInUp');
          $('#customers .slick-slide.slick-active').first().removeClass('animated fadeInUp');

          }
      });


      $('body').on('click', '.slick-prev', function() {
        if (currentSlide == 0) {
          $('#customers .slick-slide.slick-center').removeClass('animated fadeInUp');
          $('#customers .slick-slide.slick-active').last().removeClass('animated fadeInUp');
          }
      });

    }

 
  })
});
/*----------------------------------------------- CUSTOMERS SECTION (END) -----------------------------------------------*/



/*----------------------------------------------- GENERAL ANIMATE.CSS & WAYPOINT ANIMATIONS -----------------------------------------------*/
$(document).ready(function() {
  $('#core .element-to-slideInLeft').css('opacity', 0);

  if(window.matchMedia("(min-width: 769px)").matches) {
    $('#core .element-to-slideInLeft').waypoint(function() {
      $(this.element).addClass('slideInLeft');
      $(this.element).css('opacity', 1);
    }, 
    { offset: '95%' });
  }

  else {
    $('#core .element-to-slideInLeft').waypoint(function() {
      $(this.element).addClass('slideInLeft');
      $(this.element).css('opacity', 1);
    }, 
    { offset: '125%' });    
  }
});



$(document).ready(function() {
  $('#core .element-to-slideInRight').css('opacity', 0);

  if(window.matchMedia("(min-width: 769px)").matches) {
    $('#core .element-to-slideInRight').waypoint(function() {
      $(this.element).addClass('slideInRight');
      $(this.element).css('opacity', 1);
    }, 
    { offset: '95%' });
  }

  else {
    $('#core .element-to-slideInRight').waypoint(function() {
      $(this.element).addClass('slideInRight');
      $(this.element).css('opacity', 1);
    }, 
    { offset: '125%' });    
  }
});



$(document).ready(function() {
  $('#core .element-to-slideInUp').css('opacity', 0);

  if(window.matchMedia("(min-width: 769px)").matches) {
    $('#core .element-to-slideInUp').waypoint(function() {
      $(this.element).addClass('slideInUp');
      $(this.element).css('opacity', 1);
    }, 
    { offset: '95%' });
  }

  else {
    $('#core .element-to-slideInUp').waypoint(function() {
      $(this.element).addClass('slideInUp');
      $(this.element).css('opacity', 1);
    }, 
    { offset: '125%' });    
  }
});



$(document).ready(function() {
  $('#partners .element-to-fadeIn').css('opacity', 0);

  if(window.matchMedia("(min-width: 769px)").matches) {
    $('#partners .element-to-fadeIn').waypoint(function() {
      $(this.element).addClass('fadeIn');
    }, 
    { offset: '95%' });
  }

  else {
    $('#partners .element-to-fadeIn').waypoint(function() {
      $(this.element).addClass('fadeIn');
    }, 
    { offset: '125%' });    
  }
});



$(document).ready(function() {
  $('#quote .element-to-fadeIn').css('opacity', 0);

  if(window.matchMedia("(min-width: 769px)").matches) {
    $('#quote .element-to-fadeIn').waypoint(function() {
      $(this.element).addClass('fadeIn');
    }, 
    { offset: '95%' });
  }

  else {
    $('#quote .element-to-fadeIn').waypoint(function() {
      $(this.element).addClass('fadeIn');
    }, 
    { offset: '125%' });    
  }
});



$(document).ready(function() {
  $('#quote .element-to-fadeInDown').css('opacity', 0);

  if(window.matchMedia("(min-width: 769px)").matches) {
    $('#quote .element-to-fadeInDown').waypoint(function() {
      $(this.element).addClass('fadeInDown');
    }, 
    { offset: '95%' });
  }

  else {
    $('#quote .element-to-fadeInDown').waypoint(function() {
      $(this.element).addClass('fadeInDown');
    }, 
    { offset: '125%' });    
  }
});



$(document).ready(function() {
  $('#clients .element-to-fadeInUp').css('opacity', 0);

  if(window.matchMedia("(min-width: 769px)").matches) {
    $('#clients .element-to-fadeInUp').waypoint(function() {
      $(this.element).addClass('fadeInUp');
    }, 
    { offset: '95%' });
  }

  else {
    $('#clients .element-to-fadeInUp').waypoint(function() {
      $(this.element).addClass('fadeInUp');
    }, 
    { offset: '125%' });   
  }
});



$(document).ready(function() {
  $('#steps .element-to-zoomIn').css('opacity', 0);

  if(window.matchMedia("(min-width: 769px)").matches) {
    $('#steps .element-to-zoomIn').waypoint(function() {
      $(this.element).addClass('zoomIn');
      $(this.element).css('opacity', 1);
    }, 
    { offset: '95%' });
  }

  else {
    $('#steps .element-to-zoomIn').waypoint(function() {
      $(this.element).addClass('zoomIn');
      $(this.element).css('opacity', 1);
    },
    { offset: '125%' });       
  }
});



$(document).ready(function() {
  $('#steps .element-to-fadeIn').css('opacity', 0);

  if(window.matchMedia("(min-width: 769px)").matches) {
    $('#steps .element-to-fadeIn').waypoint(function() {
      $(this.element).addClass('fadeIn');
    }, 
    { offset: '95%' });
  }

  else {
    $('#steps .element-to-fadeIn').waypoint(function() {
      $(this.element).addClass('fadeIn');
    }, 
    { offset: '125%' });    
  }
});



$(document).ready(function() {
  $('#privacy .element-to-fadeInUp').css('opacity', 0);

  if(window.matchMedia("(min-width: 769px)").matches) {
    $('#privacy .element-to-fadeInUp').waypoint(function() {
      $(this.element).addClass('fadeInUp');
    }, 
    { offset: '95%' });
  }

  else {
    $('#privacy .element-to-fadeInUp').waypoint(function() {
      $(this.element).addClass('fadeInUp');
    },
    { offset: '125%' });
  }
});



$(document).ready(function() {
  $('#experts .element-to-fadeInUp').css('opacity', 0);

  if(window.matchMedia("(min-width: 769px)").matches) {
    $('#experts .element-to-fadeInUp').waypoint(function() {
      $(this.element).addClass('fadeInUp');
    }, 
    { offset: '95%' });
  } 
  else {
    $('#experts .element-to-fadeInUp').waypoint(function() {
      $(this.element).addClass('fadeInUp');
    }, 
    { offset: '130%' }); 
  }
});



$(document).ready(function() {
  $('#core-package .element-to-slideInUp').css('opacity', 0);

  if(window.matchMedia("(min-width: 769px)").matches) {
    $('#core-package .element-to-slideInUp').waypoint(function() {
      $(this.element).addClass('slideInUp');
      $(this.element).css('opacity', 1);
    }, 
    { offset: '95%' });
  }

  else {
    $('#core-package .element-to-slideInUp').waypoint(function() {
      $(this.element).addClass('slideInUp');
      $(this.element).css('opacity', 1);
    }, 
    { offset: '130%' });    
  }
});



$(document).ready(function() {

  if(window.matchMedia("(min-width: 769px)").matches) {
    $('#subscription-products .element-to-bounceInUp').waypoint(function() {
      $(this.element).addClass('bounceInUp');
    }, 
    { offset: '100%' });
  }

  else {
    $('#subscription-products .element-to-bounceInUp').waypoint(function() {
      $(this.element).addClass('bounceInUp');
    }, 
    { offset: '170%' });
  }
});
/*----------------------------------------------- GENERAL ANIMATE.CSS & WAYPOINT ANIMATIONS (END) -----------------------------------------------*/





/*----------------------------------------------- EXPERTS SECTION -----------------------------------------------*/
$(document).ready(function() {
var expertsShowButtonClickCount = 0;

$( "#experts .button-rounded-corners-border" ).on('click tap', function () {
  expertsShowButtonClickCount += 1;

  if ($(window).width() <= 439) {
    if (expertsShowButtonClickCount % 2 == 1) {
      $('#experts .image .expert:nth-child(n+4):nth-child(-n+10)').slideDown({
        start: function () {
          $(this).css({'display': 'flex'})
        }
      });
    }
    if (expertsShowButtonClickCount % 2 == 0) {
      $('#experts .image .expert:nth-child(n+4):nth-child(-n+10)').slideUp()
    }
  };

  if (($(window).width() >= 440) && ($(window).width() <= 634)) {
    if (expertsShowButtonClickCount % 2 == 1) {
      $('#experts .image .expert:nth-child(n+5):nth-child(-n+10)').slideDown({
        start: function () {
          $(this).css({'display': 'flex'})
        }
      });
    }
    if (expertsShowButtonClickCount % 2 == 0) {
      $('#experts .image .expert:nth-child(n+5):nth-child(-n+10)').slideUp()
    }
  };

  if (($(window).width() >= 635) && ($(window).width() <= 829)) {
    if (expertsShowButtonClickCount % 2 == 1) {
      $('#experts .image .expert:nth-child(n+4):nth-child(-n+10)').slideDown({
        start: function () {
          $(this).css({'display': 'flex'})
        }
      });
    }
    if (expertsShowButtonClickCount % 2 == 0) {
      $('#experts .image .expert:nth-child(n+4):nth-child(-n+10)').slideUp()
    }
  };

  if (($(window).width() >= 830) && ($(window).width() <= 1024)) {
    if (expertsShowButtonClickCount % 2 == 1) {
      $('#experts .image .expert:nth-child(n+5):nth-child(-n+10)').slideDown({
        start: function () {
          $(this).css({'display': 'flex'})
        }
      });
    }
    if (expertsShowButtonClickCount % 2 == 0) {
      $('#experts .image .expert:nth-child(n+5):nth-child(-n+10)').slideUp()
    }
  };  

  if ($(window).width() >= 1025) {
    if (expertsShowButtonClickCount % 2 == 1) {
      $('#experts .image .expert:nth-child(n+6):nth-child(-n+10)').slideDown({
        start: function () {
          $(this).css({'display': 'flex'})
        }
      });
    }
    if (expertsShowButtonClickCount % 2 == 0) {
      $('#experts .image .expert:nth-child(n+6):nth-child(-n+10)').slideUp()
    }
  };
});










// IF WINDOW RESIZED
$(window).resize(function() {

  if ($(window).width() <= 439) {
    if (expertsShowButtonClickCount % 2 == 1) {
      $('#experts .image .expert:nth-child(n+4):nth-child(-n+10)').css({'display' : 'flex'});
    }
    if (expertsShowButtonClickCount % 2 == 0) {
      $('#experts .image .expert:nth-child(-n+3)').css({'display' : 'flex'});
      $('#experts .image .expert:nth-child(n+4):nth-child(-n+10)').css({'display' : 'none'});
    }
  }

  if (($(window).width() >= 440) && ($(window).width() <= 634)) {
    if (expertsShowButtonClickCount % 2 == 1) {
      $('#experts .image .expert:nth-child(n+5):nth-child(-n+10)').css({'display' : 'flex'});
    }
    if (expertsShowButtonClickCount % 2 == 0) {
      $('#experts .image .expert:nth-child(-n+4)').css({'display' : 'flex'});
      $('#experts .image .expert:nth-child(n+5):nth-child(-n+10)').css({'display' : 'none'});
    }
  }

  if (($(window).width() >= 635) && ($(window).width() <= 829)) {
    if (expertsShowButtonClickCount % 2 == 1) {
      $('#experts .image .expert:nth-child(n+4):nth-child(-n+10)').css({'display' : 'flex'});
    }
    if (expertsShowButtonClickCount % 2 == 0) {
      $('#experts .image .expert:nth-child(-n+3)').css({'display' : 'flex'});
      $('#experts .image .expert:nth-child(n+4):nth-child(-n+10)').css({'display' : 'none'});
    }
  }

  if (($(window).width() >= 830) && ($(window).width() <= 1024)) {
    if (expertsShowButtonClickCount % 2 == 1) {
      $('#experts .image .expert:nth-child(n+5):nth-child(-n+10)').css({'display' : 'flex'});
    }
    if (expertsShowButtonClickCount % 2 == 0) {
      $('#experts .image .expert:nth-child(-n+4)').css({'display' : 'flex'});
      $('#experts .image .expert:nth-child(n+5):nth-child(-n+10)').css({'display' : 'none'});
    }
  }

  if ($(window).width() >= 1025) {
    if (expertsShowButtonClickCount % 2 == 1) {
      $('#experts .image .expert:nth-child(n+6):nth-child(-n+10)').css({'display' : 'flex'});
    }
    if (expertsShowButtonClickCount % 2 == 0) {
      $('#experts .image .expert:nth-child(-n+5)').css({'display' : 'flex'});
      $('#experts .image .expert:nth-child(n+6):nth-child(-n+10)').css({'display' : 'none'});
    }
  }

});

});







$(document).ready(function() {
// BUTTON TEXT CHANGE
$( "#experts .button-rounded-corners-border" ).on('click tap', function () {
  $(this).find('h4').text(function(i, text){
      return text === "See More" ? "See Less" : "See More";
  });
});
});
/*----------------------------------------------- EXPERTS SECTION (END) -----------------------------------------------*/
